import React, { useState, useEffect, useContext } from "react";
import { Paper, TextareaAutosize } from "@mui/material";
import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import "./../../../Style/SalesDetailStyle.scss";
import axios from "axios";
import { ApiLink } from "../../../APILink/ApiLink";
import authHeader from "../../../Auth/authHeader";
import LoginUserDetailed from "../../../Auth/LoginUserDetailed";
import jwtDecode from "jwt-decode";
import {
  deleteAlert,
  errorAlert,
  handleSuccess,
} from "../../../Components/Alerts";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import MenuItem from "@mui/material/MenuItem";
import { useHistory } from "react-router-dom";
import { FaTimes, FaTrash } from "react-icons/fa";
import { AiFillFileAdd } from "react-icons/ai";
import InsertSupplier from "../../Suppliers/InsertSuppliers";
// import InsertArticle from "../../Article/InsertArticle";
import ItemFormModal from "../../../NewCRUD/ArticleCRUD/ArticleModal";
import { detailsData } from "./FarmerPurchaseGridHeader";
import DataGridWithActions from "../../../Components/DataGridWithActions";
import Autocomplete from "@mui/material/Autocomplete";
import { getUnitID } from "../../../Auth/GetUnitCompany";
import {
  ElementsParagraph,
  TitleElements,
} from "../../../Components/HeadersCRUD-s";
import { LinkAndClickButton, AddElementsButton } from "../../../Components/AddElementsButton";
import { HeaderPaperComponent } from "../../../Components/HeaderPaperComponent";
import { FiscalYearContext } from "../../../FiscalYear/FiscalYearContext";
import CircularProgress from "@mui/material/CircularProgress";
import PrintFarmerPurchase from "../../../Print/PrintFarmerPurchase";
import AccountsAutocompleteInsert from "../../../Components/AccountsAutocompleteInsert";
import ArticleAutocompleteInsert from "../../../Components/ArticleAutocompleteInsert";
import ArticleAutocompleteEdit from "../../../Components/ArticleAutocompleteEdit";

function AddFarmerPurchase(props) {
  const history = useHistory();

  const TranscationData = [
    {
      id: 6,
      type: "Person Fizik",
    },
    {
      id: 7,
      type: "Fermer",
    },
  ];

  const headers = authHeader();
  const email = LoginUserDetailed();
  const [logedEmail, setLogedEmail] = useState("");
  const { fiscalYear } = useContext(FiscalYearContext);
  //Per insertimin e Transaction
  const [date, setDate] = useState("");
  const [payDate, setPayDate] = useState("");
  const [coment, setComent] = useState("");
  const [invoiceNR, setInvoiceNR] = useState("");
  const [supplierID, setSupplierID] = useState("");
  const [transactionsType, setTransactionType] = useState(7);
  const [paymentOptions, setPaymentOptions] = useState("");
  const [priceWithVAT, setPriceWithVAT] = useState(0);
  const [unId, setUnID] = useState("");

  const [companyType, setCompanyType] = useState("");

  //Per insertimin ne Article History
  const [articleID, setArticleID] = useState("");
  const [qtyinput, setQtyInput] = useState(0);
  const [discountPercent, setDiscountPercent] = useState(0);
  const [priceWithoutVAT, setPriceWithoutVAT] = useState(0);
  const [total, setTotal] = useState(0);
  const [vatRates, setVATRates] = useState("");

  const [tatimiNeBurim, setTatimiNeBurim] = useState(0);
  const [newVATPercent, setNewVATPercent] = useState(1);

  const [perqindjaZbritjes, setPerqindjaZbritjes] = useState(0);
  const [totalWithDiscountAmount, setTotalWithDiscountAmount] = useState(0);

  // kjo konstante sherben per ta mbaajtur perkohesisht qmimin me tvsh te nje artikulli
  const [tempPriceWithVAT, setTempPriceWithVAT] = useState(0);

  const [showDeleteTransactionID, setShowDeleteTransactionID] = useState(false);

  const [deleteItemId, setDeleteItemId] = useState(null);
  const [deleteTransactionID, setDeleteTransactionID] = useState("");

  const [openDetails, setOpenDetails] = useState(false);

  const [data, setData] = useState([]);

  const [cashRegister, setCashRegister] = useState([]);

  const [suppliers, setSuppliers] = useState([]);
  // const [filteredSuppliers, setFilteredSuppliers] = useState([]);

  const [suppliersDetails, setSuppliersDetails] = useState([]);

  const [articles, setArticles] = useState([]);
  // const [filteredArticles, setFilteredArticles] = useState([]);

  const [valuedetails, setValueDetails] = useState([]);

  // Te dhenat per printim
  const [headerData, setHeaderData] = useState([]);
  const [companiesData, setCompaniesData] = useState([]);
  const [companyID, setcompanyID] = useState("");
  const [articlePrintDetails, setArticlePrintDetails] = useState([]);
  const [bankAccounts, setBankAccounts] = useState([]);

  const [form1IsDisabled, setForm1IsDisabled] = useState(false);
  const [form2IsDisabled, setForm2IsDisabled] = useState(true);

  //Keto konstante jan perdorur per ti shfaqur progres bar tek butonat
  const [insertingTransaction, setInsertingTransaction] = useState(false);
  const [insertingArticle, setInsertingArticle] = useState(false);

  const [minDate, setMinDate] = useState("");
  const [maxDate, setMaxDate] = useState("");

  useEffect(() => {
    setMinDate(`${fiscalYear}-01-01`);
    setMaxDate(`${fiscalYear}-12-31`);
  }, [fiscalYear]);

  //   const handleDateChange = (e) => {
  //     const selectedDate = e.target.value;
  //     const selectedYear = new Date(selectedDate).getFullYear();

  //     // Kontrollo që data të jetë brenda vitit të caktuar
  //     if (selectedYear === fiscalYear) {
  //       setDate(selectedDate);
  //       setPayDate(selectedDate);
  //       checkInvoiceNumber(invoiceNR);
  //       fetchLastInvoiceNr(fiscalYear);
  //     } else {
  //       setDate(""); // Reset data në rast të gabuar
  //     }
  //   };

  const handleDateChange = (e) => {
    const selectedDate = e.target.value;

    setDate(selectedDate);

    if (selectedDate.length < 10) return;

    const selectedYear = Number(selectedDate.substring(0, 4));

    if (selectedYear === fiscalYear) {
      setDate(selectedDate);
      setPayDate(selectedDate);
      checkInvoiceNumber(invoiceNR);
      fetchLastInvoiceNr(fiscalYear);
    } else {
    }
  };

  const handleEnable = () => {
    setForm1IsDisabled(true);
    setForm2IsDisabled(false);
  };
  // keto konstante sherbejn per ta mbajtur gjendjen e formave nese jane hide ose jo
  const [showEditForm, setShowEditForm] = useState(false);
  const [showInserForm, setShowInsertForm] = useState(true);
  // ky kod i ndryshon gjendjet e formave

  const handleOpenForm2 = () => {
    setShowInsertForm(true);
    setShowEditForm(false); // I fsheh formën e parë
    setArticleID();
    setQtyInput(0);
    setDiscountPercent(0);
    setPriceWithoutVAT(0);
    setPriceWithVAT(0);
    setTotal(0);
  };
  const handleOpenForm1 = () => {
    setShowInsertForm(false);
    setShowEditForm(true); // I fsheh formën e parë
  };

  const newInvoice = () => {
    const currentDate = new Date();
    // const year = currentDate.getFullYear();
    const month = String(currentDate.getMonth() + 1).padStart(2, "0");
    const day = String(currentDate.getDate()).padStart(2, "0");
    const formattedDate = `${fiscalYear}-${month}-${day}`;

    setForm1IsDisabled(false);
    setForm2IsDisabled(true);
    setOpenDetails(false);
    setArticleID();
    setQtyInput(0);
    setPriceWithoutVAT(0);
    setPriceWithVAT(0);
    setTotal(0);
    fetchLastInvoiceNr(fiscalYear);
    setInvoiceNR("");
    setDate(formattedDate);
    setPayDate(formattedDate);
    setComent("");
    setTransactionType(7);
    setPaymentOptions("");
    setSupplierID("");
    // setSupplierName("");
    setSuppliersDetails([]);
    setData([]);
    setValueDetails([]);
    setAccfield(null);
  };

  const handleEditDetails = (item) => {
    handleOpenForm1();
    fetchArticlesSalesPrice(item.ArticleID, "getVat");
    setFormDetailData({
      HistoryID: item.HistoryID,
      ArticleID: item.ArticleID,
      QtyInput: item.QtyInput,
      DiscountPercent: item.DiscountPercent,
      PriceBeforeDiscount: item.PriceBeforeDiscount,
      Total: item.Total,
      PriceWithVAT: item.PriceWithVAT,
      PriceWithoutVAT: item.PriceWithoutVAT,
      ModifiedByUser: logedEmail,
      InvoiceNr: invoiceNR,
      PaymentOptions: paymentOptions,
    });
  };

  const clearEdit = () => {
    setFormDetailData({
      HistoryID: "",
      ArticleID: "",
      QtyInput: 0,
      PriceWithVAT: 0,
      PriceWithoutVAT: 0,
      setFormDetailData: 0,
    });

    clearLine();
    handleOpenForm2();
  };

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      const decodedToken = jwtDecode(token);
      setLogedEmail(decodedToken.email);
    }
  }, []);

  const fetchData = async () => {
    try {
      const response = await axios.get(
        ApiLink.API_URL + "FarmerPurchaseDetail/purchasedetails",
        { headers, params: { invNumber: invoiceNR, fiscalYear: fiscalYear } },
      );
      setData(response.data);
    } catch (error) {
      errorAlert("Gabim në kërkesë:");
      if (
        error.response &&
        error.response.data &&
        error.response.data.errorMessage
      ) {
        errorAlert(`Gabim në marrjen e të dhënave`);
      } else if (error.message) {
        errorAlert(`Gabim`);
      } else {
        errorAlert("Gabim i panjohur në kërkesë. Shih konsolën për detaje.");
      }
    }
  };

  //Kodi sherben per ta marr id e transaksionit qe sherben me pas per ta bere delete
  const fetchTransactionID = async () => {
    try {
      const response = await axios.get(
        ApiLink.API_URL + "FarmerPurchaseDetail/GetTransactionID",
        {
          headers,
          params: {
            email: logedEmail,
            invNumber: invoiceNR,
            fiscalYear: fiscalYear,
          },
        },
      );
      setDeleteTransactionID(response.data);

      // Kontrollo nëse nuk ka të dhëna të disponueshme
      if (response.data.length === 0) {
        // Shfaqi një mesazh për përdoruesin
        // errorAlert("No data available.");
      }
    } catch (error) {
      // Shfaqi një mesazh për përdoruesin për gabimin e tjera
      // setMessage("Error: Failed to fetch data.");
    }
  };

  // i merr te dhenat nga databaza per te ja shfaqur vlerat userit
  const fetchvaluedetails = async () => {
    try {
      const response = await axios.get(
        ApiLink.API_URL + "FarmerPurchaseDetail/getvaluedetails",
        { headers, params: { invNumber: invoiceNR, fiscalYear: fiscalYear } },
      );
      setValueDetails(response.data);
      setTotalWithDiscountAmount(
        response.data[0].Total + response.data[0].DiscountAmount,
      );

      const total = response.data[0]?.Total;

      if (total == null || isNaN(total)) {
        setTatimiNeBurim(0);
      } else {
        if (companyType === "BI") {
          setTatimiNeBurim(total * 0.03);
          setNewVATPercent(3);
        } else {
          setTatimiNeBurim(total * 0.01);
          setNewVATPercent(1);
        }
      }
    } catch (error) {
      errorAlert("Gabim në kërkesë:");

      if (
        error.response &&
        error.response.data &&
        error.response.data.errorMessage
      ) {
        errorAlert(`Gabim në marrjen e të dhënave`);
      } else if (error.message) {
        errorAlert(`Gabim`);
      } else {
        errorAlert("Gabim i panjohur në kërkesë. Shih konsolën për detaje.");
      }
    }
  };

  const fetchHeaderData = async () => {
    try {
      const response = await axios.get(
        ApiLink.API_URL + "SalesInDetails/GetPrintHeaderDetails",
        {
          headers,
          params: {
            invNumber: invoiceNR,
            actionType: "POF",
            fiscalYear: fiscalYear,
          },
        },
      );
      setHeaderData(response.data);
    } catch (error) {
      errorAlert("Gabim në kërkesë:");
      if (
        error.response &&
        error.response.data &&
        error.response.data.errorMessage
      ) {
        errorAlert(`Gabim në marrjen e të dhënave`);
      } else if (error.message) {
        errorAlert(`Gabim`);
      } else {
        errorAlert("Gabim i panjohur në kërkesë. Shih konsolën për detaje.");
      }
    }
  };

  const fetchArticleDataPrint = async () => {
    try {
      const response = await axios.get(
        ApiLink.API_URL + "Article/GetArticleDetailsForPrint",
        {
          headers,
          params: {
            invNumber: invoiceNR,
            actionType: "POF",
            fiscalYear: fiscalYear,
          },
        },
      );
      setArticlePrintDetails(response.data);
    } catch (error) {
      errorAlert("Gabim në kërkesë:");

      if (
        error.response &&
        error.response.data &&
        error.response.data.errorMessage
      ) {
        errorAlert(`Gabim në marrjen e të dhënave`);
      } else if (error.message) {
        errorAlert(`Gabim`);
      } else {
        errorAlert("Gabim i panjohur në kërkesë. Shih konsolën për detaje.");
      }
    }
  };

  const fetchBanksAccount = async () => {
    try {
      const response = await axios.get(
        ApiLink.API_URL + "Accounts/BankDetails",
        { headers },
      );
      setBankAccounts(response.data);
    } catch (error) {
      errorAlert("Gabim në kërkesë:");
      if (
        error.response &&
        error.response.data &&
        error.response.data.errorMessage
      ) {
        errorAlert(`Gabim në marrjen e të dhënave`);
      } else if (error.message) {
        errorAlert(`Gabim`);
      } else {
        errorAlert("Gabim i panjohur në kërkesë. Shih konsolën për detaje.");
      }
    }
  };

  const fetchLastInvoiceNr = async (fiscalY) => {
    try {
      const response = await axios.get(
        ApiLink.API_URL + "FarmerPurchaseDetail/InvoiceNr",
        { headers, params: { fiscalYear: fiscalY } },
      );
      setInvoiceNR(response.data.NextInvoiceNr);
    } catch (error) {
      errorAlert("Gabim në kërkesë:", error);
      if (
        error.response &&
        error.response.data &&
        error.response.data.errorMessage
      ) {
        errorAlert(
          `Gabim në marrjen e të dhënave: ${error.response.data.errorMessage}`,
        );
      } else if (error.message) {
        errorAlert(`Gabim: ${error.message}`);
      } else {
        errorAlert("Gabim i panjohur në kërkesë. Shih konsolën për detaje.");
      }
    }
  };
  const fetchCompaniesData = async () => {
    try {
      const response = await axios.get(
        ApiLink.API_URL + "Companies/getCompanyDetails",
        { headers },
      );
      setCompaniesData(response.data);
      setcompanyID(response.data[0].CompanyID);
      setCompanyType(response.data[0].CompanyType);

      if (response.data[0].CompanyType === "BI") {
        setNewVATPercent(3);
      } else {
        setNewVATPercent(1);
      }
    } catch (error) {
      errorAlert("Gabim në kërkesë:");
      if (
        error.response &&
        error.response.data &&
        error.response.data.errorMessage
      ) {
        errorAlert(`Gabim në marrjen e të dhënave`);
      } else if (error.message) {
        errorAlert(`Gabim`);
      } else {
        errorAlert("Gabim i panjohur në kërkesë. Shih konsolën për detaje.");
      }
    }
  };

  const fetchPaymentType = async () => {
    try {
      const response = await axios.get(
        ApiLink.API_URL + "Accounts/paymenttype",
        { headers },
      );
      setCashRegister(response.data);
    } catch (error) {
      errorAlert("Gabim në kërkesë");
      if (
        error.response &&
        error.response.data &&
        error.response.data.errorMessage
      ) {
        errorAlert(`Gabim në marrjen e të dhënave`);
      } else if (error.message) {
        errorAlert(`Gabim`);
      } else {
        errorAlert("Gabim i panjohur në kërkesë. Shih konsolën për detaje.");
      }
    }
  };

  const handleDelete = async (deleteItemId) => {
    try {
      // const response =
      await axios.delete(
        ApiLink.API_URL + "FarmerPurchaseDetail/oneline" + `/${deleteItemId}`,
        {
          headers,
          params: {
            email: logedEmail,
            invoiceNR: invoiceNR,
            fiscalYear: fiscalYear,
          },
        },
      );
      deleteAlert("Linja është fshirë me sukses");

      fetchData();
      fetchvaluedetails();
      fetchHeaderData();
      fetchArticleDataPrint();
    } catch (error) {
      deleteAlert("Linja nuk është fshirë");
    }
  };

  // Kodi per fshirjen e nje elementi ne databaz
  const handleDeleteTransactionID = async () => {
    try {
      // const response =
      await axios.delete(
        ApiLink.API_URL + "FarmerPurchaseDetail" + `/${deleteTransactionID}`,
        { headers },
      );
      setShowDeleteTransactionID(false);
      deleteAlert("Fatura blerjes është fshirë me sukses");
      setPaymentOptions("");
      setSupplierID();
      history.push("/purchases/FarmerPurchase"); // Zëvendëso 'your-desired-path' me path-in e dëshiruar
    } catch (error) {
      deleteAlert("Fatura blerjes nuk është fshirë");
    }
  };

  const fetchSuppliers = async () => {
    try {
      const response = await axios.get(
        ApiLink.API_URL + "Accounts/accountByLedger",
        { headers, params: { ledger: 302 } },
      );
      setSuppliers(response.data);
    } catch (error) {
      errorAlert("Gabim në kërkesë:");
      if (
        error.response &&
        error.response.data &&
        error.response.data.errorMessage
      ) {
        errorAlert(`Gabim në marrjen e të dhënave`);
      } else if (error.message) {
        errorAlert(`Gabim`);
      } else {
        errorAlert("Gabim i panjohur në kërkesë. Shih konsolën për detaje.");
      }
    }
  };

  const fetchSuppliersDetails = async () => {
    try {
      const response = await axios.get(
        ApiLink.API_URL + "Accounts/accountByID",
        { headers, params: { id: supplierID } },
      );
      setSuppliersDetails(response.data);
    } catch (error) {
      errorAlert("Gabim në kërkesë:");
      if (
        error.response &&
        error.response.data &&
        error.response.data.errorMessage
      ) {
        errorAlert(`Gabim në marrjen e të dhënave`);
      } else if (error.message) {
        errorAlert(`Gabim`);
      } else {
        errorAlert("Gabim i panjohur në kërkesë. Shih konsolën për detaje.");
      }
    }
  };

  const fetchArticles = async () => {
    try {
      const response = await axios.get(ApiLink.API_URL + "Article", {
        headers,
      });
      setArticles(response.data);
    } catch (error) {
      errorAlert("Gabim në kërkesë");
      if (
        error.response &&
        error.response.data &&
        error.response.data.errorMessage
      ) {
        errorAlert(`Gabim në marrjen e të dhënave`);
      } else if (error.message) {
        errorAlert(`Gabim`);
      } else {
        errorAlert("Gabim i panjohur në kërkesë. Shih konsolën për detaje.");
      }
    }
  };

  const [buttonContent, setButtonContent] = useState({
    text: "Hap Detalet e Faturës",
    backgroundColor: "#4E7B67",
    transcation: "background-color 0.3s ease",
    onMouseEnter: "#284945",
    onMouseLeave: "#4E7B67",
  });
  const [invNumberExist, setInvNumberExist] = useState();
  const checkInvoiceNumber = async (invoiceNR) => {
    try {
      const response = await axios.get(
        ApiLink.API_URL + "FarmerPurchaseDetail/invoiceExists",
        { headers, params: { invNumber: invoiceNR, fiscalYear: fiscalYear } },
      );
      setInvNumberExist(response.data[0].InvoiceCount);
      if (response.data[0].InvoiceCount > 0) {
        setButtonContent({
          text: "Numri i faturës ekziston në listë",
          backgroundColor: "red",
          transcation: "background-color 0.3s red",
          onMouseEnter: "red",
          onMouseLeave: "red",
        });
      } else {
        setButtonContent({
          text: "Hap Detalet e Faturës",
          backgroundColor: "#4E7B67",
          transcation: "background-color 0.3s ease",
          onMouseEnter: "#284945",
          onMouseLeave: "#4E7B67",
        });
      }
    } catch (error) {
      // errorAlert("Gabim në kërkesë:", error);
      if (
        error.response &&
        error.response.data &&
        error.response.data.errorMessage
      ) {
        errorAlert(`Gabim në marrjen e të dhënave`);
      } else if (error.message) {
        // errorAlert(`Gabim: ${error.message}`);
      } else {
        errorAlert("Gabim i panjohur në kërkesë. Shih konsolën për detaje.");
      }
    }
  };

  useEffect(() => {
    const currentDate = new Date();
    const year = currentDate.getFullYear();
    const month = String(currentDate.getMonth() + 1).padStart(2, "0");
    const day = String(currentDate.getDate()).padStart(2, "0");
    const formattedDate = `${year}-${month}-${day}`;

    if (fiscalYear === year) {
      setDate(formattedDate);
      setPayDate(formattedDate);
    } else {
      setDate("");
      setPayDate("");
    }
  }, [fiscalYear]);
  const fetchArticlesSalesPrice = async (articleID, form) => {
    try {
      const response = await axios.get(
        ApiLink.API_URL + "Article/GetSalesPrice",
        { headers, params: { articleID: articleID } },
      );
      const salesPriceData = response.data; // Merr të dy vlerat e "SalesPrice" dhe "VATRates" nga përgjigja

      if (form == "edit") {
        const calculatedValue =
          (parseFloat(response.data.PurchasePrice) * 100) /
          (100 + response.data.PurchasePrice);
        // setInsertPriceWithoutVAT(calculatedValue.toFixed(2));
        setVATRates(response.data.VATRates);

        setFormDetailData((prevState) => ({
          ...prevState,
          PriceWithVAT: response.data.PurchasePrice,
          PriceWithoutVAT: calculatedValue,
          DiscountPercent: 0,
          QtyInput: 1,
          PriceBeforeDiscount: response.data.PurchasePrice,
          Total: 1 * response.data.PurchasePrice,
        }));
      } else if (form == "getVat") {
        setVATRates(response.data.VATRates);
        // alert("get vat" + vatRates)
      } else {
        setPriceWithVAT(salesPriceData.PurchasePrice);
        setVATRates(salesPriceData.VATRates);
        setQtyInput(1);
        // Kalkulimi i vlerës pa TVSH dhe vendosja e saj tek PriceWithoutVAT
        const calculatedValue =
          (parseFloat(salesPriceData.PurchasePrice) * 100) /
          (100 + salesPriceData.VATRates);
        setPriceWithoutVAT(calculatedValue.toFixed(2));
        setTotal(1 * salesPriceData.PurchasePrice);
      }
    } catch (error) {
      errorAlert("Gabim në kërkesë:");
      if (
        error.response &&
        error.response.data &&
        error.response.data.errorMessage
      ) {
        errorAlert(`Gabim në marrjen e të dhënave`);
      } else if (error.message) {
        errorAlert(`Gabim`);
      } else {
        errorAlert("Gabim i panjohur në kërkesë. Shih konsolën për detaje.");
      }
    }
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    setInsertingTransaction(true);
    if (!invoiceNR) {
      errorAlert("Ju lutem plotësoni numrin e faturës!");
      setInsertingTransaction(false);
      return;
    }
    if (!date) {
      errorAlert("Ju lutem plotësoni Daten!");
      setInsertingTransaction(false);
      return;
    }
    if (!paymentOptions) {
      errorAlert("Ju lutem plotësoni mënyren e pagesës!");
      setInsertingTransaction(false);
      return;
    }
    if (!supplierID) {
      errorAlert("Ju lutem plotësoni furnitorin!");
      setInsertingTransaction(false);
      return;
    }
    if (paymentOptions != 0 && payDate == "") {
      errorAlert("Ju lutem plotësoni Daten e pagesës!");
      setInsertingTransaction(false);
      return;
    }
    const stateDate = {
      Date: date,
      PayDate: paymentOptions !== 0 ? payDate : null,
      InvoiceNr: invoiceNR,
      SupplierID: supplierID,
      TransactionType: transactionsType,
      ActionType: "POF",
      PaymentOptions: paymentOptions,
      CompanyUnitID: unId > 0 ? unId : null,
      Coment: coment,
      CreatedByUser: email,
    };
    axios
      .post(ApiLink.API_URL + "FarmerPurchaseDetail/invoicedetail", stateDate, {
        headers,
      })
      .then(() => {
        handleSuccess("Fatura u regjistrua me sukses");
        handleEnable();
        setOpenDetails(true);
        fetchHeaderData();
        fetchTransactionID();
        setInsertingTransaction(false);
      })
      .catch((error) => {
        setInsertingTransaction(false);
        // console.error(error);
        if (error.response && error.response.status === 409) {
          setInsertingTransaction(false);
          errorAlert(error.response.data);
        } else {
          setInsertingTransaction(false);
          errorAlert("Gabim gjatë regjistrimit të faturës");
        }
      });
  };

  const handleNewSubmit = (event) => {
    event.preventDefault();
    setInsertingArticle(true);
    if (!invoiceNR) {
      errorAlert("Ju lutem plotësoni numrin e faturës!");
      setInsertingArticle(false);
      return;
    }
    if (articleID == "" || articleID == null) {
      errorAlert("Ju lutem plotësoni artikullin");
      setInsertingArticle(false);
      return;
    }
    if (qtyinput == "" || qtyinput == null) {
      errorAlert("Ju lutem plotësoni sasin");
      setInsertingArticle(false);
      return;
    }
    // Shtoni kontrollet këtu
    if (isNaN(qtyinput)) {
      errorAlert("Sasia e produkteve (qty input) duhet të jetë një numër.");
      setInsertingArticle(false);
      return;
    }
    if (isNaN(priceWithoutVAT)) {
      errorAlert("Çmimi pa TVSH (priceWithoutVAT) duhet të jetë një numër.");
      setInsertingArticle(false);
      return;
    }
    if (isNaN(priceWithVAT)) {
      errorAlert("Çmimi me TVSH (priceWithVAT) duhet të jetë një numër.");
      setInsertingArticle(false);
      return;
    }
    if (isNaN(total)) {
      errorAlert("Totali duhet të jetë një numër.");
      setInsertingArticle(false);
      return;
    }
    const stateDate = {
      InvoiceNr: invoiceNR,
      ArticleID: articleID,
      QtyInput: qtyinput,
      DiscountPercent: discountPercent,
      PriceBeforeDiscount: tempPriceWithVAT,
      PriceWithoutVAT: priceWithoutVAT,
      PriceWithVAT: priceWithVAT,
      CompanyUnitID: unId > 0 ? unId : null,
      CreatedByUser: email,
      Date: date,
      SupplierID: supplierID,
    };
    axios
      .post(ApiLink.API_URL + "FarmerPurchaseDetail/createnewline", stateDate, {
        headers,
        params: { vatRates: vatRates, newVATRates: newVATPercent },
      })
      .then(() => {
        handleSuccess("Linja është shtuar me sukses");
        setArticleID();
        setQtyInput(0);
        setPriceWithoutVAT(0);
        setPriceWithVAT(0);
        setTotal(0);
        fetchData();
        fetchvaluedetails();
        fetchHeaderData();
        fetchArticleDataPrint();
        // setArticlesName("");
        setDiscountPercent(0);
        setTempPriceWithVAT(0);
        setField(null);
        setInsertingArticle(false);
      })
      .catch((error) => {
        setInsertingArticle(false);
        // console.error(error);
        if (error.response && error.response.status === 409) {
          setInsertingArticle(false);
          errorAlert(error.response.data);
        } else {
          setInsertingArticle(false);
          errorAlert("Gabim gjatë regjistrimit të linjës");
        }
      });
  };
  const clearLine = () => {
    setArticleID();
    setQtyInput(0);
    setPriceWithoutVAT(0);
    setPriceWithVAT(0);
    setTotal(0);
    fetchData();
    fetchvaluedetails();
    fetchHeaderData();
    fetchArticleDataPrint();
    // setArticlesName("");
    setDiscountPercent(0);
    setTempPriceWithVAT(0);
  };

  const [formDetailData, setFormDetailData] = useState({
    HistoryID: "",
    ArticleID: "",
    QtyInput: "",
    DiscountPercent: "",
    PriceBeforeDiscount: "",
    Total: "",
    PriceWithVAT: "",
    PriceWithoutVAT: "",
    ModifiedByUser: "",
    InvoiceNr: "",
    PaymentOptions: "",
  });

  // Kodi per ruajtjen e te dhenave pas editimint
  const handleInputChangeDetail = (event) => {
    const { name, value } = event.target;
    setFormDetailData({ ...formDetailData, [name]: value });
  };
  const handleSubmitDetailLine = (event) => {
    event.preventDefault();
    axios
      .put(
        ApiLink.API_URL + "FarmerPurchaseDetail/updatedetailsArticle",
        formDetailData,
        {
          headers,
          params: {
            vatRates: vatRates,
            fiscalYear: fiscalYear,
            newVATRates: newVATPercent,
          },
        },
      )
      .then((response) => {
        // fetchDetailLineData(invoiceNR);
        fetchvaluedetails();
        // updateAlert("Detail updated successfully");
        fetchArticleDataPrint();
        fetchHeaderData();
        fetchData();
        handleOpenForm2();
      })
      .catch((error) => {
        // console.log(error);
        errorAlert("Deshtoi editimi i linjës");
      });
  };

  const handleCalculatePriceWithVAT = async (type) => {
    try {
      if (isNaN(priceWithoutVAT)) {
        throw new Error(
          "Çmimi pa TVSH (priceWithoutVAT) duhet të jetë një numër.",
        );
      }

      if (isNaN(qtyinput)) {
        throw new Error(
          "Sasia e produkteve (qty input) duhet të jetë një numër.",
        );
      }
      if (type === "edit") {
        // Veprimet specifike për rastin e editimit
        const vat =
          Number(formDetailData.PriceWithoutVAT) * (Number(vatRates) / 100);
        const calculatedPriceWithVAT =
          Number(formDetailData.PriceWithoutVAT) + vat;
        const total = Number(formDetailData.QtyInput) * calculatedPriceWithVAT;

        // setTempPriceWithVAT(Number(formDetailData.PriceWithVAT) / (1 - (Number(formDetailData.DiscountPercent) / 100)))
        setTempPriceWithVAT(
          Number(calculatedPriceWithVAT) /
            (1 - Number(formDetailData.DiscountPercent) / 100),
        );

        setFormDetailData((prevState) => ({
          ...prevState,
          PriceWithVAT: calculatedPriceWithVAT,
          Total: total,
          PriceBeforeDiscount: tempPriceWithVAT,
        }));
      } else {
        const vat = Number(priceWithoutVAT) * (Number(vatRates) / 100);
        const calculatedPriceWithVAT = Number(priceWithoutVAT) + vat;
        const total = Number(qtyinput) * calculatedPriceWithVAT;
        // Veprimet specifike për shtim të ri
        setPriceWithVAT(calculatedPriceWithVAT);
        setTotal(total);

        setTempPriceWithVAT(
          Number(calculatedPriceWithVAT) / (1 - Number(discountPercent) / 100),
        );
      }
    } catch (error) {
      errorAlert("Gabim ne kalkulim");
    }
  };
  const handleCalculatePriceWithoutVAT = async (type) => {
    try {
      if (isNaN(priceWithVAT)) {
        throw new Error(
          "Çmimi me TVSH (priceWithVAT) duhet të jetë një numër.",
        );
      }

      if (isNaN(qtyinput)) {
        throw new Error(
          "Sasia e produkteve (qty input) duhet të jetë një numër.",
        );
      }

      if (type === "edit") {
        // Veprimet specifike për rastin e editimit
        const calculatedPriceWithoutVAT =
          (Number(formDetailData.PriceWithVAT) * 100) /
          (100 + Number(vatRates));
        const total =
          Number(formDetailData.QtyInput) * Number(formDetailData.PriceWithVAT);
        setTempPriceWithVAT(
          Number(formDetailData.PriceWithVAT) /
            (1 - Number(formDetailData.DiscountPercent) / 100),
        );

        setFormDetailData((prevState) => ({
          ...prevState,
          PriceWithoutVAT: calculatedPriceWithoutVAT,
          Total: total,
          PriceBeforeDiscount: tempPriceWithVAT,
        }));
      } else {
        // Veprimet specifike për shtim të ri
        const calculatedPriceWithoutVAT =
          (Number(priceWithVAT) * 100) / (100 + Number(vatRates));
        const total = Number(qtyinput) * Number(priceWithVAT);

        setTempPriceWithVAT(
          Number(priceWithVAT) / (1 - Number(discountPercent) / 100),
        );

        setPriceWithoutVAT(calculatedPriceWithoutVAT);
        setTotal(total);
      }
    } catch (error) {
      errorAlert("Gabim ne kalkulim");
    }
  };
  const handleCalculatePrices = async (type) => {
    try {
      if (isNaN(qtyinput)) {
        throw new Error(
          "Sasia e produkteve (qty input) duhet të jetë një numër.",
        );
      }

      if (isNaN(total)) {
        throw new Error("Totali duhet të jetë një numër.");
      }

      if (type === "edit") {
        // Veprimet specifike për rastin e editimit
        const priceWithVAT =
          Number(formDetailData.Total) / Number(formDetailData.QtyInput);

        // const calculatedPriceWithoutVAT = formDetailData.PriceWithVAT * 100 / (100 + Number(vatRates));
        const calculatedPriceWithoutVAT =
          (priceWithVAT * 100) / (100 + Number(vatRates));

        const tempPriceWithVATEdit =
          Number(priceWithVAT) /
          (1 - Number(formDetailData.DiscountPercent) / 100.0);

        // setTempPriceWithVAT(Number(formDetailData.PriceWithVAT) / (1 - (Number(formDetailData.DiscountPercent) / 100)))

        setFormDetailData((prevState) => ({
          ...prevState,
          PriceWithVAT: priceWithVAT,
          PriceWithoutVAT: calculatedPriceWithoutVAT,
          PriceBeforeDiscount: tempPriceWithVATEdit,
        }));
      } else {
        // Veprimet specifike për shtim të ri
        const priceWithVAT = Number(total) / Number(qtyinput);
        const calculatedPriceWithoutVAT =
          (priceWithVAT * 100) / (100 + Number(vatRates));

        setTempPriceWithVAT(
          Number(priceWithVAT) / (1 - Number(discountPercent) / 100),
        );

        setPriceWithoutVAT(calculatedPriceWithoutVAT);
        setPriceWithVAT(priceWithVAT);
      }
    } catch (error) {
      errorAlert("Gabim ne kalkulim");
    }
  };

  const handleCalculatePriceWithRabat = async (type) => {
    try {
      if (isNaN(discountPercent)) {
        throw new Error("% e rabatit (Rabati) duhet të jetë një numër.");
      }

      if (type === "edit") {
        // Veprimet specifike për rastin e editimit
        setTempPriceWithVAT(formDetailData.PriceBeforeDiscount);

        const vleraZbritjes =
          tempPriceWithVAT * (formDetailData.DiscountPercent / 100);
        const priceWithVATRabat =
          Number(tempPriceWithVAT) - Number(vleraZbritjes);

        const calculatedPriceWithoutVAT =
          (Number(priceWithVATRabat) * 100) / (100 + Number(vatRates));
        const total =
          Number(formDetailData.QtyInput) * Number(priceWithVATRabat);

        setFormDetailData((prevState) => ({
          ...prevState,
          PriceWithoutVAT: calculatedPriceWithoutVAT,
          PriceWithVAT: priceWithVATRabat,
          Total: total,
          PriceBeforeDiscount: tempPriceWithVAT,
        }));
      } else {
        // Veprimet specifike për shtim të ri
        const vleraZbritjes = tempPriceWithVAT * (discountPercent / 100);
        const priceWithVATRabat =
          Number(tempPriceWithVAT) - Number(vleraZbritjes);

        const calculatedPriceWithoutVAT =
          (Number(priceWithVATRabat) * 100) / (100 + Number(vatRates));
        const total = Number(qtyinput) * Number(priceWithVATRabat);

        setPriceWithoutVAT(calculatedPriceWithoutVAT);
        setPriceWithVAT(priceWithVATRabat);
        setTotal(total);
      }
    } catch (error) {
      errorAlert("Gabim ne kalkulim");
    }
  };

  const calculateAndSetPaymentDate = (pay) => {
    // Supozojmë që 'date' është një objekt i vlefshëm Date.
    // Nëse jo, duhet të krijohet si i tillë.
    let paymentDate = new Date(date); // Kjo siguron që paymentDate të jetë një objekt Date.

    if (pay === "0") {
      // Shtojmë 5 ditë nëse paymentOptions është "0"
      paymentDate.setDate(paymentDate.getDate() + 5); // Përdor getDate() për të marrë ditën dhe pastaj shto 5
      const formattedDate = paymentDate.toISOString().split("T")[0];
      setPayDate(formattedDate);
    } else {
      // Supozojmë që 'date' është formatuar siç duhet
      setPayDate(date);
    }
  };

  useEffect(() => {
    // Kontrollo nqs supplierID është ndryshuar para se të kryhen veprimet
    if (supplierID !== "") {
      fetchSuppliersDetails();
    }
  }, [supplierID]);

  const [isArticleModalOpen, setIsArticleModalOpen] = useState(false);

  const [accField, setAccfield] = useState(null);
  //Pjesa per select input field supplier
  // const handleAutocompleteChangeSuppliers = (event, value) => {
  //   if (value && value.AccountID) {
  //     setSupplierID(value.AccountID);
  //     setAccfield(value);
  //     fetchLastInvoiceNr(fiscalYear);
  //   } else {
  //     // Në rast se vlera është pastruar
  //     setSupplierID(""); // Vendos vlerën e ArticleID në null
  //   }
  // };

  // const defaultPropsSuppliers = {
  //   options: suppliers,
  //   getOptionLabel: (option) =>
  //     `${option.IdentificationNumber} - ${option.AccountName}` || "",
  //   renderOption: (props, option) => (
  //     <>
  //       <li {...props} style={{ borderBottom: "1px solid lightgray" }}>
  //         <span>
  //           {option.IdentificationNumber}
  //           <br />
  //           {option.AccountName}
  //         </span>
  //       </li>
  //     </>
  //   ),
  // };

  //Kodi ka detyr qe nese lloji i peson Fizik, te vendoset TVSH 0
  useEffect(() => {
    if (transactionsType == 1) {
      setVATRates(0);
    }
  });

  useEffect(() => {
    fetchLastInvoiceNr(fiscalYear);
  }, [fiscalYear]);

  //////

  const [field, setField] = useState(null);
  // const handleAutocompleteChangeArticle = (event, value) => {
  //   if (value && value.ArticleID) {
  //     setArticleID(value.ArticleID);
  //     fetchArticlesSalesPrice(value.ArticleID);
  //     setField(value);
  //   } else {
  //     // Në rast se vlera është pastruar
  //     setArticleID(""); // Vendos vlerën e ArticleID në null
  //     setField(null);
  //   }
  // };

  // const defaultPropsArticle = {
  //   options: articles,
  //   getOptionLabel: (option) =>
  //     `${option.Barcode} - ${option.ArticleName}` || "",
  //   renderOption: (props, option) => (
  //     <>
  //       <li {...props} style={{ borderBottom: "1px solid lightgray" }}>
  //         <span>
  //           {option.Barcode}
  //           <br />
  //           {option.ArticleName}
  //         </span>
  //         <label style={{ marginLeft: "auto", fontWeight: "bold" }}>
  //           {/* {option.SalesPrice}€ */}
  //           {option.PurchasePrice !== null && option.PurchasePrice !== 0
  //             ? option.PurchasePrice.toLocaleString("en-US", {
  //                 minimumFractionDigits: 2,
  //               })
  //             : "0.00"}
  //           €
  //         </label>
  //         {/* <button
  //                       onClick={(e) => {
  //                           e.stopPropagation();
  //                           // handleButtonClick(option);
  //                       }}
  //                       onMouseEnter={handleOpen}
  //                       onMouseLeave={handleClose}
  //                       style={{ marginLeft: 'auto' }}
  //                   >
  //                       Click
  //                   </button> */}
  //       </li>
  //     </>
  //   ),
  // };

  ////////////////////////

  // const handleAutocompleteChangeArticleEdit = (event, value) => {
  //   if (value) {
  //     setFormDetailData((prevState) => ({
  //       ...prevState,
  //       ArticleID: value.ArticleID,
  //     }));
  //     fetchArticlesSalesPrice(value.ArticleID, "edit");
  //   } else {
  //     setFormDetailData((prevState) => ({
  //       ...prevState,
  //       ArticleID: "",
  //     }));
  //   }
  // };

  // const defaultPropsArticleEdit = {
  //   options: articles,
  //   getOptionLabel: (option) =>
  //     `${option.Barcode} - ${option.ArticleName}` || "",
  //   renderOption: (props, option) => (
  //     <>
  //       <li {...props} style={{ borderBottom: "1px solid lightgray" }}>
  //         <span>
  //           {option.Barcode}
  //           <br />
  //           {option.ArticleName}
  //         </span>
  //         <label style={{ marginLeft: "auto", fontWeight: "bold" }}>
  //           {option.PurchasePrice !== null && option.PurchasePrice !== 0
  //             ? option.PurchasePrice.toLocaleString("en-US", {
  //                 minimumFractionDigits: 2,
  //               })
  //             : "0.00"}
  //           €
  //         </label>
  //         {/* <button
  //                       onClick={(e) => {
  //                           e.stopPropagation();
  //                           // handleButtonClick(option);
  //                       }}
  //                       style={{ marginLeft: 'auto' }}
  //                   >
  //                       click me
  //                   </button> */}
  //       </li>
  //     </>
  //   ),
  // };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      let nextField;
      switch (e.target.id) {
        case "ArticleID":
          nextField = document.getElementById("QtyInput");
          break;
        case "QtyInput":
          nextField = document.getElementById("PriceWithVAT");
          break;
        case "PriceWithoutVAT":
          nextField = document.getElementById("PriceWithVAT");
          break;
        case "PriceWithVAT":
          nextField = document.getElementById("Total");
          break;
        case "DiscountPercent":
          nextField = document.getElementById("PriceWithVAT");
          break;
        case "Total":
          if (showEditForm === true && showInserForm === false) {
            handleSubmitDetailLine(e);
          } else if (showInserForm === true && showEditForm === false) {
            handleNewSubmit(e);
          }
          nextField = document.getElementById("ArticleID");
          break;
        default:
          return;
      }
      if (nextField && nextField.select) {
        nextField.focus();
        nextField.select(); // Shtoni këtë rresht për të selektuar tekstin
      }
    }
  };

  const detailsRows = data.map((item, index) => ({
    id: ++index,
    barcode: item.Barcode,
    article: item.ArticleName,
    qty: item.QtyInput,
    PBD: item.PriceWithoutVATBeforeDiscount,
    discount: item.DiscountPercent,
    norma: item.VATRates,
    PNoVAT: item.PriceWithoutVAT,
    PVAT: item.PriceWithVAT,
    amountNoVAT: item.Amount,
    vat: item.VAT,
    amountVAT: item.Total,
    rowInfo: item,
    deleteItemId: item.HistoryID,
  }));

  //E merr unit id nga nje klas tjeter
  useEffect(() => {
    getUnitID(headers).then(setUnID);
  }, [headers]);

  useEffect(() => {
    fetchData();
    fetchSuppliers();
    fetchArticles();
    fetchHeaderData();
    fetchCompaniesData();
    fetchBanksAccount();
    fetchTransactionID();
    fetchPaymentType();
  }, [logedEmail, invoiceNR, supplierID, articleID, deleteItemId, fiscalYear]);

  return (
    <div className="SalesDetail__Container" style={{ paddingTop: "50px" }}>
      <Modal
        show={showDeleteTransactionID}
        onHide={() => setShowDeleteTransactionID(false)}
        style={{ marginTop: "150px" }}
      >
        <Modal.Header>
          <Modal.Title>Confirmation</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>Are you sure you want to delete this invoice?</p>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => setShowDeleteTransactionID(false)}
          >
            No
          </Button>
          <Button variant="danger" onClick={handleDeleteTransactionID}>
            Yes
          </Button>
        </Modal.Footer>
      </Modal>
      <br></br>
      <TitleElements
        icon={AiFillFileAdd}
        title="Blerje e re nga fermeret në detale"
      />
      {/* <div className="header_paragraph">
                <p>Ju lutemi vini re se të gjitha te dhenat ruhen automatikisht në bazën e të dhënave për të pasur siguri në cdo hap!</p>
            </div> */}
      <ElementsParagraph text="Ju lutemi vini re se të gjitha te dhenat ruhen automatikisht në bazën e të dhënave për të pasur siguri në cdo hap!" />

      <hr></hr>
      <div className="SalesDetail__Container__AllButtons">
        <div style={{ display: "flex" }}>
          <div>
            <InsertSupplier
              // fetchData={fetchSuppliers}
              type="insert"
              nif={"NIF"}
            />
          </div>
          <div style={{ marginLeft: "5px" }}>
            {/* <InsertArticle type="insert" /> */}
            <AddElementsButton
              text="Krijo Artikull"
              onClick={() => setIsArticleModalOpen(true)}
              icon="bi bi-upc-scan"
              className="button-15"
            />
            <ItemFormModal
              isOpen={isArticleModalOpen}
              onClose={() => setIsArticleModalOpen(false)}
              onSuccess={() => setIsArticleModalOpen(false)}
              itemToEdit={null}
            />
          </div>
        </div>
        <div style={{ display: "flex" }}>
          <div style={{ marginLeft: "5px" }}>
            <LinkAndClickButton
              text="Ruaj & i ri"
              link="#"
              onClick={() => {
                newInvoice();
              }} // ose funksioni yt këtu
            />
          </div>
          <div style={{ marginLeft: "5px" }}>
            {/* <PrintContent details={headerData} companyDetails={companiesData} articleDetails={articlePrintDetails} bankaccounts={bankAccounts} QTY="QtyInput" sasia="QtyInput" actiontype="false" /> */}
            <PrintFarmerPurchase
              details={headerData}
              companyDetails={companiesData}
              articleDetails={articlePrintDetails}
              bankaccounts={bankAccounts}
              companyType={companyType}
            />
          </div>
          <div style={{ marginLeft: "5px" }}>
            <LinkAndClickButton
              text="Fshij"
              icon={<FaTrash />}
              link="#"
              onClick={() => {
                setShowDeleteTransactionID(true);
              }}
            />
          </div>
          <div style={{ marginLeft: "5px" }}>
            <LinkAndClickButton
              text="Mbyll"
              icon={<FaTimes />}
              link="/purchases/FarmerPurchase"
            />
          </div>
        </div>
      </div>
      <HeaderPaperComponent />
      <Paper>
        <form onSubmit={handleSubmit} className="header_paper">
          <Box
            // component="form"
            sx={{
              "& .MuiTextField-root": { m: 1.3, width: "41ch" },
            }}
            noValidate
            autoComplete="off"
          >
            {/* <p>Please fill in these fields first to proceed to the fields below</p> */}
            <div className="SalesDetail__Container__Form">
              <div className="SalesDetail__Container__Form__div">
                <div
                  className="SalesDetail__Container__Form__div__1"
                  style={{ marginTop: "13px" }}
                >
                  <div className="SalesDetail__Container__Form__div__2">
                    <TextField
                      className="SalesDetail__Container__Form__TextField__1"
                      required
                      id="invoiceNR"
                      label="Numri i Faturës"
                      variant="outlined"
                      type="text"
                      name="InvoiceNr"
                      value={"POF-" + fiscalYear + "-" + invoiceNR}
                      onChange={(event) => {
                        setInvoiceNR(event.target.value);
                        checkInvoiceNumber(event.target.value);
                      }}
                      disabled={form1IsDisabled}
                      autoComplete="off"
                    />
                    <TextField
                      className="SalesDetail__Container__Form__TextField__1"
                      style={{ marginTop: "22px" }}
                      id="id"
                      select
                      label="Përzgjedh Tipin e Transaksionit"
                      defaultValue=""
                      value={transactionsType}
                      onChange={(event) => {
                        setTransactionType(event.target.value);
                        fetchLastInvoiceNr(fiscalYear);
                      }}
                      required
                      disabled={form1IsDisabled}
                    >
                      {TranscationData.map((data) => (
                        <MenuItem key={data.id} value={data.id}>
                          {data.type}
                        </MenuItem>
                      ))}
                    </TextField>
                    <TextareaAutosize
                      style={{
                        height: "55px",
                        marginLeft: "10px",
                        marginTop: "12px",
                      }}
                      className="SalesDetail__Container__Form__TextField__1"
                      id="Comment"
                      label="Komenti"
                      type="text"
                      name="Comment"
                      value={coment}
                      onChange={(event) => setComent(event.target.value)}
                      variant="outlined"
                      disabled={form1IsDisabled}
                      autoComplete="off"
                    />
                  </div>
                  <div className="SalesDetail__Container__Form__TextField__date__Payment">
                    {/* <TextField
                      className="SalesDetail__Container__Form__TextField__date"
                      id="date"
                      type="date"
                      variant="outlined"
                      label="Data e Faturës"
                      name="Date"
                      value={date}
                      // onChange={(e) => setDate(e.target.value)}
                      // onChange={event => { setDate(event.target.value); setPayDate(event.target.value); checkInvoiceNumber(invoiceNR); }}
                      onChange={handleDateChange}
                      disabled={form1IsDisabled}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      inputProps={{
                        min: minDate, // Kufizimi minimal i datës
                        max: maxDate, // Kufizimi maksimal i datës
                      }}
                    /> */}
                    <TextField
                      className="SalesDetail__Container__Form__TextField__date"
                      id="date"
                      type="date"
                      variant="outlined"
                      name="Date"
                      label="Data Faturës"
                      value={date}
                      onChange={handleDateChange}
                      disabled={form1IsDisabled}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      inputProps={{
                        min: minDate,
                        max: maxDate,
                      }}
                    />
                    <TextField
                      className="SalesDetail__Container__Form__TextField__Payment"
                      style={{ marginTop: "22px" }}
                      id="PaymentType"
                      select
                      label="Përzgjedh Mënyrën e Pagesës"
                      // defaultValue=""
                      // helperText="Please select expense"
                      value={paymentOptions}
                      disabled={form1IsDisabled}
                      // onChange={event => setPaymentOptions(event.target.value)}
                      onChange={(event) => {
                        setPaymentOptions(event.target.value);
                        calculateAndSetPaymentDate(event.target.value);
                        fetchLastInvoiceNr(fiscalYear);
                      }}
                      // disabled={form1IsDisabled}
                    >
                      <MenuItem key="0" value="0">
                        Pagesa Behet më vonë
                      </MenuItem>
                      {cashRegister.map((data) => (
                        <MenuItem key={data.AccountID} value={data.AccountID}>
                          {data.AccountName}
                        </MenuItem>
                      ))}
                    </TextField>
                    {paymentOptions != 0 ? (
                      <TextField
                        className="SalesDetail__Container__Form__TextField__date"
                        id="PayDate"
                        type="date"
                        variant="outlined"
                        label="Data pagesës"
                        name="PayDate"
                        value={payDate}
                        // onChange={(e) => setDate(e.target.value)}
                        onChange={(event) => {
                          setPayDate(event.target.value);
                          fetchLastInvoiceNr(fiscalYear);
                        }}
                        disabled={form1IsDisabled}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        inputProps={{
                          min: minDate, // Kufizimi minimal i datës
                          max: maxDate, // Kufizimi maksimal i datës
                        }}
                      />
                    ) : (
                      <TextField
                        className="SalesDetail__Container__Form__TextField__date"
                        id="PayDate"
                        type="date"
                        variant="outlined"
                        label="Afati pagesës"
                        name="PayDate"
                        value={payDate}
                        // onChange={(e) => setDate(e.target.value)}
                        onChange={(event) => {
                          setPayDate(event.target.value);
                          fetchLastInvoiceNr(fiscalYear);
                        }}
                        disabled={form1IsDisabled}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        inputProps={{
                          min: minDate, // Kufizimi minimal i datës
                          max: maxDate, // Kufizimi maksimal i datës
                        }}
                      />
                    )}
                  </div>
                </div>
              </div>
              <div className="SalesDetail__Container__Form__div__4">
                <div style={{ paddingTop: "10px" }}>
                  {/* <Autocomplete
                    {...defaultPropsSuppliers}
                    id="include-input-in-list"
                    includeInputInList
                    onChange={handleAutocompleteChangeSuppliers}
                    value={accField}
                    isOptionEqualToValue={(option, value) =>
                      option.AccountID === value.AccountID
                    } // Shto funksionin isOptionEqualToValue
                    renderInput={(params) => (
                      <TextField
                        style={{ width: "95%" }}
                        {...params}
                        label="Kerko Furnitorin"
                        disabled={form1IsDisabled}

                        // variant="filled"
                        //   onKeyPress={handleKeyPress}
                      />
                    )}
                  /> */}
                  <AccountsAutocompleteInsert
                    ledgerID={302}
                    value={accField}
                    label="Kerko Furnitorin"
                    onSelect={(account) => {
                      setSupplierID(account.AccountID);
                      setAccfield(account);
                      fetchLastInvoiceNr(fiscalYear);
                    }}
                    onClear={() => {
                      setSupplierID("");
                      setAccfield(null);
                    }}
                    labelId="AccountID"
                  />
                </div>
                <div style={{ display: "flex", paddingTop: "15px" }}>
                  <TextField
                    className="SalesDetail__Container__Form__TextField__IDNumber"
                    id="outlined-basic"
                    label="Numri Identifikues"
                    variant="outlined"
                    name="IdentificationNumber"
                    value={
                      suppliersDetails.length > 0
                        ? suppliersDetails[0].IdentificationNumber
                        : ""
                    }
                    InputLabelProps={{
                      shrink: true,
                    }}
                    readOnly
                    autoComplete="off"
                  />
                  <TextField
                    className="SalesDetail__Container__Form__TextField__IDNumber"
                    id="outlined-basic"
                    label="NIF"
                    variant="outlined"
                    name="VatNumber"
                    value={
                      suppliersDetails.length > 0
                        ? suppliersDetails[0].VATNumber
                        : ""
                    }
                    InputLabelProps={{
                      shrink: true,
                    }}
                    readOnly
                    autoComplete="off"
                  />
                </div>
                <div>
                  <TextField
                    className="SalesDetail__Container__Form__TextField__2"
                    id="outlined-basic"
                    label="Adresa"
                    variant="outlined"
                    name="Address"
                    value={
                      suppliersDetails.length > 0
                        ? suppliersDetails[0].Adress
                        : ""
                    }
                    InputLabelProps={{
                      shrink: true,
                    }}
                    readOnly
                    autoComplete="off"
                  />
                </div>
              </div>
            </div>
          </Box>
        </form>
        {openDetails ? (
          <div className="SalesDetail__Container">
            <div style={{ backgroundColor: "gainsboro " }}>
              <hr></hr>
              {showInserForm && (
                <form
                  onSubmit={handleNewSubmit}
                  className="header_paper"
                  onKeyPress={handleKeyPress}
                >
                  <Box
                    // component="form"
                    sx={{
                      "& .MuiTextField-root": { m: 1.3, width: "41ch" },
                    }}
                    noValidate
                    autoComplete="off"
                  >
                    <div className="SalesDetail__Container__Second__Form">
                      <div
                        className="SalesDetail__Container__Second__Form__Article"
                        style={{ paddingTop: "12px" }}
                      >
                        {/* <Autocomplete
                          fullWidth
                          {...defaultPropsArticle}
                          id="ArticleID"
                          sx={{ m: 1.5 }}
                          includeInputInList
                          value={field}
                          onChange={handleAutocompleteChangeArticle}
                          isOptionEqualToValue={(option, value) =>
                            option.ArticleID === value.ArticleID
                          } // Shto funksionin isOptionEqualToValue
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label="Kerko Artikullin"
                              // variant="filled"
                              // onKeyPress={handleKeyPress}
                            />
                          )}
                          ListboxProps={{
                            style: {
                              maxHeight: "250px", // Caktoni një lartësi maksimale për të lejuar vetëm 4 elemente
                              overflow: "auto", // Aktivizoni scroll-in për pjesën tjetër
                            },
                          }}
                        /> */}
                        <ArticleAutocompleteInsert
                          // reloadKey={articlesReloadKey}
                          value={field}
                          label="Kerko Artikullin"
                          priceType="purchase"
                          onSelect={(article) => {
                            setArticleID(article.ArticleID);
                            fetchArticlesSalesPrice(article.ArticleID);
                            setField(article);
                          }}
                          onClear={() => {
                            setArticleID("");
                            setField(null);
                          }}
                          labelId="ArticleID"
                        />
                      </div>
                      <div className="SalesDetail__Container__Second__Form__details__OtherInputs">
                        <div
                          className="SalesDetail__Container__Second__Form__details"
                          style={{ paddingTop: "14px" }}
                        >
                          <TextField
                            className="SalesDetail__Container__Form__TextField__Output"
                            id="QtyInput"
                            type="text"
                            variant="outlined"
                            label="QTY Input"
                            name="QtyInput"
                            value={
                              typeof qtyinput === "number"
                                ? qtyinput.toFixed(4)
                                : qtyinput
                            }
                            onChange={(e) => setQtyInput(e.target.value)}
                            onKeyUp={handleCalculatePriceWithoutVAT} // Shtoni këtë për të shkaktuar një funksion pas humbjes së fokusit nga kjo fushë
                            disabled={form2IsDisabled}
                          />
                        </div>
                        <div className="SalesDetail__Container__Second__Form__details">
                          <TextField
                            className="SalesDetail__Container__Form__TextField__Output"
                            id="DiscountPercent"
                            type="text"
                            variant="outlined"
                            label="Rabati %"
                            name="DiscountPercent"
                            value={
                              typeof discountPercent === "number"
                                ? discountPercent.toFixed(2)
                                : discountPercent
                            }
                            onChange={(e) => setDiscountPercent(e.target.value)}
                            onKeyUp={handleCalculatePriceWithRabat} // Shtoni këtë për të shkaktuar një funksion pas humbjes së fokusit nga kjo fushë
                            disabled={form2IsDisabled}
                          />
                        </div>
                        <div
                          className="SalesDetail__Container__Second__Form__details"
                          style={{ paddingTop: "14px" }}
                        >
                          <TextField
                            className="SalesDetail__Container__Form__TextField__Output"
                            id="PriceWithoutVAT"
                            type="text"
                            variant="outlined"
                            label="Price Without VAT"
                            name="PriceWithoutVAT"
                            value={
                              typeof priceWithoutVAT === "number"
                                ? priceWithoutVAT.toFixed(4)
                                : priceWithoutVAT
                            }
                            onKeyUp={handleCalculatePriceWithVAT}
                            onChange={(e) => setPriceWithoutVAT(e.target.value)}
                            disabled={form2IsDisabled}
                            InputLabelProps={{
                              shrink: true,
                            }}
                          />
                        </div>
                        <div className="SalesDetail__Container__Second__Form__details">
                          <TextField
                            className="SalesDetail__Container__Form__TextField__Output"
                            id="PriceWithVAT"
                            type="text"
                            variant="outlined"
                            label="Price With VAT"
                            name="PriceWithVAT"
                            value={
                              typeof priceWithVAT === "number"
                                ? priceWithVAT.toFixed(4)
                                : priceWithVAT
                            }
                            onChange={(e) => setPriceWithVAT(e.target.value)}
                            onKeyUp={handleCalculatePriceWithoutVAT} // Shtoni këtë për të shkaktuar një funksion pas humbjes së fokusit nga kjo fushë
                            disabled={form2IsDisabled}
                            InputLabelProps={{
                              shrink: true,
                            }}
                          />
                        </div>
                        <div className="SalesDetail__Container__Second__Form__details">
                          <TextField
                            className="SalesDetail__Container__Form__TextField__Output"
                            id="Total"
                            label="Total"
                            variant="outlined"
                            name="Total"
                            value={
                              typeof total === "number"
                                ? total.toFixed(2)
                                : total
                            }
                            onChange={(event) => setTotal(event.target.value)}
                            onKeyUp={handleCalculatePrices}
                            InputLabelProps={{
                              shrink: true,
                            }}
                            disabled={form2IsDisabled}
                          />
                        </div>
                        <div className="butonat">
                          <div>
                            <Button
                              type="submit"
                              variant="success"
                              disabled={form2IsDisabled}
                              style={{
                                borderRadius: "0",
                                width: "45px",
                                height: "45px",
                              }}
                            >
                              {insertingArticle ? (
                                <CircularProgress
                                  style={{
                                    borderRadius: "0",
                                    color: "white",
                                    width: "30px",
                                    height: "30px",
                                    alignItems: "center",
                                  }}
                                />
                              ) : (
                                <i class="bi bi-plus-lg"></i>
                              )}
                              {/* <i class="bi bi-plus-lg"></i> */}
                            </Button>
                          </div>
                          <div>
                            <Button
                              variant="danger"
                              onClick={clearLine}
                              style={{ width: "40px", height: "40px" }}
                            >
                              <i class="bi bi-x-lg"></i>
                            </Button>
                          </div>
                        </div>
                        <div className="responsive">
                          <div className="responsive__butonat">
                            <div>
                              <Button
                                type="submit"
                                variant="success"
                                disabled={form2IsDisabled}
                                style={{
                                  borderRadius: "0",
                                  width: "45px",
                                  height: "45px",
                                }}
                              >
                                {insertingArticle ? (
                                  <CircularProgress
                                    style={{
                                      borderRadius: "0",
                                      color: "white",
                                      width: "30px",
                                      height: "30px",
                                      alignItems: "center",
                                    }}
                                  />
                                ) : (
                                  <i class="bi bi-plus-lg"></i>
                                )}
                                {/* <i class="bi bi-plus-lg"></i> */}
                              </Button>
                            </div>
                            <div>
                              <Button
                                variant="danger"
                                onClick={clearLine}
                                style={{
                                  borderRadius: "0",
                                  width: "45px",
                                  height: "45px",
                                }}
                              >
                                <i class="bi bi-x-lg"></i>
                              </Button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Box>
                </form>
              )}
              {showEditForm && (
                <div className="SalesDetail__Container">
                  <form
                    onSubmit={handleSubmitDetailLine}
                    className="header_paper"
                    onKeyPress={handleKeyPress}
                  >
                    <Box
                      // component="form"
                      sx={{
                        "& .MuiTextField-root": { m: 1.3, width: "41ch" },
                      }}
                      noValidate
                      autoComplete="off"
                    >
                      {/* <p style={{ color: "red", fontSize: "16px", fontStyle: "italic", borderBottom: "1px dashed red" }}>Click on a line to edit the data</p> */}
                      <div className="SalesDetail__Container__Second__Form">
                        <div
                          className="SalesDetail__Container__Second__Form__Article"
                          style={{ paddingTop: "12px" }}
                        >
                          {/* <Autocomplete
                            fullWidth
                            sx={{ m: 1.5 }}
                            {...defaultPropsArticleEdit}
                            id="ArticleID"
                            includeInputInList
                            onChange={handleAutocompleteChangeArticleEdit}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label="Artikulli"
                                // variant="filled"
                              />
                            )}
                            ListboxProps={{
                              style: {
                                maxHeight: "250px", // Caktoni një lartësi maksimale për të lejuar vetëm 4 elemente
                                overflow: "auto", // Aktivizoni scroll-in për pjesën tjetër
                              },
                            }}
                            value={
                              articles.find(
                                (option) =>
                                  option.ArticleID === formDetailData.ArticleID,
                              ) || null
                            }
                          /> */}
                          <ArticleAutocompleteEdit
                            articleId={formDetailData.ArticleID}
                            labelId="ArticleID"
                            priceType="purchase"
                            label="Furnitori"
                            onSelect={(article) => {
                              setFormDetailData((prev) => ({
                                ...prev,
                                ArticleID: article.ArticleID,
                              }));
                              fetchArticlesSalesPrice(
                                article.ArticleID,
                                "edit",
                              );
                            }}
                            onClear={() =>
                              setFormDetailData((prev) => ({
                                ...prev,
                                ArticleID: "",
                              }))
                            }
                          />
                        </div>
                        <div className="SalesDetail__Container__Second__Form__details__OtherInputs">
                          <div className="SalesDetail__Container__Second__Form__details">
                            <TextField
                              className="SalesDetail__Container__Form__TextField__Output"
                              type="text"
                              id="QtyInput"
                              name="QtyInput"
                              label="Sasia Hyrje"
                              variant="outlined"
                              autoComplete="off"
                              value={formDetailData.QtyInput}
                              onChange={handleInputChangeDetail}
                              onKeyUp={() =>
                                handleCalculatePriceWithoutVAT("edit")
                              }
                            />
                          </div>
                          <div className="SalesDetail__Container__Second__Form__details">
                            <TextField
                              className="SalesDetail__Container__Form__TextField__Output"
                              id="DiscountPercent"
                              type="text"
                              variant="outlined"
                              label="Rabati %"
                              name="DiscountPercent"
                              autoComplete="off"
                              value={
                                typeof formDetailData.DiscountPercent ===
                                "number"
                                  ? formDetailData.DiscountPercent.toFixed(2)
                                  : formDetailData.DiscountPercent
                              }
                              onChange={handleInputChangeDetail}
                              onKeyUp={() =>
                                handleCalculatePriceWithRabat("edit")
                              } // Shtoni këtë për të shkaktuar një funksion pas humbjes së fokusit nga kjo fushë
                            />
                          </div>
                          <div className="SalesDetail__Container__Second__Form__details">
                            <TextField
                              className="SalesDetail__Container__Form__TextField__Output"
                              id="PriceWithoutVAT"
                              type="text"
                              variant="outlined"
                              label="Çmimi pa TVSH"
                              name="PriceWithoutVAT"
                              autoComplete="off"
                              value={
                                typeof formDetailData.PriceWithoutVAT ===
                                "number"
                                  ? formDetailData.PriceWithoutVAT.toFixed(4)
                                  : formDetailData.PriceWithoutVAT
                              }
                              onChange={handleInputChangeDetail}
                              onKeyUp={() =>
                                handleCalculatePriceWithVAT("edit")
                              }
                              // disabled={form2IsDisabled}
                            />
                          </div>
                          <div className="SalesDetail__Container__Second__Form__details">
                            <TextField
                              className="SalesDetail__Container__Form__TextField__Output"
                              id="PriceWithVAT"
                              type="text"
                              variant="outlined"
                              label="Çmimi me TVSH"
                              name="PriceWithVAT"
                              autoComplete="off"
                              value={
                                typeof formDetailData.PriceWithVAT === "number"
                                  ? formDetailData.PriceWithVAT.toFixed(4)
                                  : formDetailData.PriceWithVAT
                              }
                              onChange={handleInputChangeDetail}
                              onKeyUp={() =>
                                handleCalculatePriceWithoutVAT("edit")
                              }
                            />
                          </div>
                          <div className="SalesDetail__Container__Second__Form__details">
                            <TextField
                              className="SalesDetail__Container__Form__TextField__Output"
                              id="Total"
                              label="Total"
                              variant="outlined"
                              // name='Amount'
                              name="Total"
                              autoComplete="off"
                              value={
                                typeof formDetailData.Total === "number"
                                  ? formDetailData.Total.toFixed(2)
                                  : formDetailData.Total
                              }
                              onChange={handleInputChangeDetail}
                              onKeyUp={() => handleCalculatePrices("edit")}
                              InputLabelProps={{
                                shrink: true,
                              }}
                            />
                          </div>

                          <div className="butonat">
                            <div>
                              <Button
                                type="submit"
                                variant="success"
                                style={{
                                  borderRadius: "0",
                                  width: "45px",
                                  height: "45px",
                                }}
                              >
                                <i class="bi bi-check-lg"></i>
                              </Button>
                            </div>
                            <div>
                              <Button
                                variant="danger"
                                onClick={clearEdit}
                                style={{
                                  borderRadius: "0",
                                  width: "45px",
                                  height: "45px",
                                }}
                              >
                                <i class="bi bi-x-lg"></i>
                              </Button>
                            </div>
                          </div>
                          <div className="responsive">
                            <div className="responsive__butonat">
                              <div>
                                <Button
                                  type="submit"
                                  variant="success"
                                  style={{
                                    borderRadius: "0",
                                    width: "45px",
                                    height: "45px",
                                  }}
                                >
                                  <i class="bi bi-check-lg"></i>
                                </Button>
                              </div>
                              <div>
                                <Button
                                  variant="danger"
                                  onClick={clearEdit}
                                  style={{
                                    borderRadius: "0",
                                    width: "45px",
                                    height: "45px",
                                  }}
                                >
                                  <i class="bi bi-x-lg"></i>
                                </Button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </Box>
                  </form>
                </div>
              )}
              <DataGridWithActions
                columns={detailsData}
                rows={detailsRows}
                handleEdit={handleEditDetails}
                handleDelete={handleDelete}
                showPayment={false}
              />
            </div>
            <br></br>
            <div className="responsive__Tablet">
              <div className="SalesDetail__Container__Form">
                <div>
                  <TextField
                    className="SalesDetail__Container__Form__TextField__Amount18"
                    // style={{ width: "100%" }}
                    id="Amount18"
                    label="Vlera 18%"
                    variant="outlined"
                    type="text"
                    name="Amount18"
                    value={
                      valuedetails.length > 0
                        ? valuedetails[0].Amount18.toFixed(2)
                        : ""
                    }
                    disabled
                  />
                  <br></br>
                  <br></br>
                  <TextField
                    className="SalesDetail__Container__Form__TextField__VAT18"
                    // style={{ width: "100%" }}
                    id="VAT18"
                    label="TVSH 18%"
                    variant="outlined"
                    type="text"
                    name="VAT18"
                    value={
                      valuedetails.length > 0
                        ? valuedetails[0].VAT18.toFixed(2)
                        : ""
                    }
                    disabled
                  />
                </div>
                <br></br>
                <div>
                  <TextField
                    className="SalesDetail__Container__Form__TextField__Amount8"
                    // style={{ width: "100%" }}
                    id="Amount8"
                    label="Vlera 8%"
                    variant="outlined"
                    type="text"
                    name="Amount8"
                    value={
                      valuedetails.length > 0
                        ? valuedetails[0].Amount8.toFixed(2)
                        : ""
                    }
                    disabled
                  />
                  <br></br>
                  <br></br>
                  <TextField
                    className="SalesDetail__Container__Form__TextField__VAT8"
                    // style={{ width: "100%" }}
                    id="VAT8"
                    label="TVSH 8%"
                    variant="outlined"
                    type="text"
                    name="VAT8"
                    value={
                      valuedetails.length > 0
                        ? valuedetails[0].VAT8.toFixed(2)
                        : ""
                    }
                    disabled
                  />
                </div>
                <br></br>
                <div>
                  <TextField
                    className="SalesDetail__Container__Form__TextField__Amount0"
                    // style={{ width: "100%" }}
                    id="Amount0"
                    label="Vlera 0%"
                    variant="outlined"
                    type="text"
                    name="Amount0"
                    value={
                      valuedetails.length > 0
                        ? valuedetails[0].Amount0.toFixed(2)
                        : ""
                    }
                    readOnly
                  />
                  <br></br>
                  <br></br>
                  <TextField
                    className="SalesDetail__Container__Form__TextField__VAT0"
                    // style={{ width: "100%" }}
                    id="VAT0"
                    label="Vlera me TVSH"
                    variant="outlined"
                    type="text"
                    name="VAT0"
                    value={
                      valuedetails.length > 0
                        ? valuedetails[0].Total.toFixed(2)
                        : ""
                    }
                    readOnly
                  />
                </div>
                <br></br>
                <div>
                  <TextField
                    className="SalesDetail__Container__Form__TextField__TotalAmount"
                    id="TotalAmount"
                    label="Total pa TVSH"
                    variant="outlined"
                    type="text"
                    name="TotalAmount"
                    value={
                      valuedetails.length > 0
                        ? (
                            valuedetails[0].Amount18 +
                            valuedetails[0].Amount8 +
                            valuedetails[0].Amount0
                          ).toFixed(2)
                        : ""
                    }
                    readOnly
                  />
                  <br></br>
                  <br></br>
                  <TextField
                    className="SalesDetail__Container__Form__TextField__TotalAmount"
                    id="TatimiBurim"
                    label="Tatimi në burim"
                    variant="outlined"
                    type="text"
                    name="TatimiBurim"
                    value={tatimiNeBurim}
                    readOnly
                  />
                </div>
                <br></br>
                <div>
                  <TextField
                    className="SalesDetail__Container__Form__TextField__VATTotal"
                    // style={{ width: "100%" }}
                    id="VATTotal"
                    label="Total TVSH"
                    variant="outlined"
                    type="text"
                    name="VATTotal"
                    value={
                      valuedetails.length > 0
                        ? (
                            valuedetails[0].Total -
                            (valuedetails[0].Amount18 +
                              valuedetails[0].Amount8 +
                              valuedetails[0].Amount0)
                          ).toFixed(2)
                        : ""
                    }
                    readOnly
                  />
                  <br></br>
                  <br></br>
                  <TextField
                    className="SalesDetail__Container__Form__TextField__Total"
                    // style={{ width: "100%" }}
                    id="Totali"
                    label="Për pagesë"
                    variant="outlined"
                    type="text"
                    name="Totali"
                    value={
                      valuedetails.length > 0
                        ? (valuedetails[0].Total - tatimiNeBurim).toFixed(2)
                        : ""
                    }
                    readOnly
                  />
                </div>
              </div>
            </div>
          </div>
        ) : (
          <>
            <div
              style={{
                display: "flex",
                justifyContent: "space-around",
                width: "100%",
              }}
              onHide
            >
              {insertingTransaction ? (
                <button
                  className="button-15"
                  variant="contained"
                  // type="submit"
                  style={{
                    background: "#4E7B67",
                    width: "95%",
                    height: "55px",
                    alignContent: "center",
                    transition: "background-color 0.3s ease",
                    boxShadow: "0 0 5px rgba(0, 0, 0, 0.3)",
                    color: "white",
                    border: "none",
                  }}
                >
                  <CircularProgress style={{ color: "white" }} />
                </button>
              ) : (
                <button
                  className="button-15"
                  variant="contained"
                  type="submit"
                  style={{
                    background: buttonContent.backgroundColor,
                    width: "95%",
                    height: "55px",
                    alignContent: "center",
                    transition: buttonContent.transcation,
                    boxShadow: "0 0 5px rgba(0, 0, 0, 0.3)",
                    color: "white",
                    border: "none",
                  }}
                  disabled={form1IsDisabled}
                  // onClick={handleSubmit}
                  onClick={invNumberExist > 0 ? null : handleSubmit}
                  onMouseEnter={(e) => {
                    e.target.style.backgroundColor = buttonContent.onMouseEnter;
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.backgroundColor = buttonContent.onMouseLeave;
                  }}
                >
                  {buttonContent.text}
                </button>
              )}
            </div>
          </>
        )}
        <br></br>
      </Paper>
    </div>
  );
}

export default AddFarmerPurchase;
